import { ButtonFilterOptions } from '@/components/custom';
import { getSelectOptions } from '@/functions';

import { useQueryParams } from '@/hooks';
import { ISelectOption } from '@/interfaces';

const VARIABLES = {
    keyNameType: 'type',
    keyNameStatus: 'status'
};

interface TProps {
    isLoading?: boolean;
}

const HeaderPageFilters = ({ isLoading }: TProps) => {
    const { updateSearchParams, urlSearchParams } = useQueryParams([]);

    const filterOptions = {
        type: urlSearchParams.getAll(VARIABLES.keyNameType),
        status: urlSearchParams.getAll(VARIABLES.keyNameStatus)
    };

    const handleOnChangeFilter = (key: string, options: ISelectOption[]) =>
        updateSearchParams(prevUrlSearchParams => {
            const currentValues = prevUrlSearchParams.getAll(key);
            currentValues.forEach(option => prevUrlSearchParams.delete(key, option));
            options.forEach(option => prevUrlSearchParams.append(key, option.value as string));
            return prevUrlSearchParams;
        });

    return (
        <div className='flex flex-wrap gap-2'>
            <ButtonFilterOptions
                disabled={isLoading}
                options={getSelectOptions('AccountingUserTypeEnum')}
                onChange={options => handleOnChangeFilter(VARIABLES.keyNameType, options)}
                value={filterOptions.type}
                text='Type' />
            <ButtonFilterOptions
                disabled={isLoading}
                options={getSelectOptions('AccountingUserStatusEnum')}
                onChange={options => handleOnChangeFilter(VARIABLES.keyNameStatus, options)}
                value={filterOptions.status}
                text='Statut' />
        </div>
    );
};

export default HeaderPageFilters;
